import { STEPS } from "../config/stepsConfig";

export const stripUndefined = (value) => {
  if (Array.isArray(value)) return value.map(stripUndefined);
  if (value && typeof value === "object" && !(value instanceof File)) {
    return Object.entries(value).reduce((acc, [k, v]) => {
      if (v !== undefined) acc[k] = stripUndefined(v);
      return acc;
    }, {});
  }
  return value;
};

export const buildInitialFormData = () =>
  STEPS.reduce((acc, step) => {
    acc[step.key] = structuredClone(step.initialData);
    return acc;
  }, {});

export const getLeadIdFromUrl = (searchParams) => searchParams.get("leadId");

export const normalizeValue = (value) => {
  if (value === null || value === undefined) return "";

  if (value instanceof File) {
    return {
      name: value.name,
      size: value.size,
      type: value.type,
      lastModified: value.lastModified,
    };
  }

  if (Array.isArray(value)) {
    return value.map(normalizeValue);
  }

  if (typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        result[key] = normalizeValue(value[key]);
        return result;
      }, {});
  }

  return value;
};

export const isEqual = (first, second) =>
  JSON.stringify(normalizeValue(first)) ===
  JSON.stringify(normalizeValue(second));

export const getInitialStepFromLead = (lead) => {
  if (!lead) return null;

  if (lead.isFinancierChangeRequest) {
    return 3;
  }

  if (lead.eligibleFinanciers?.length > 0 || lead.loanSummary) {
    return 3;
  }

  if (
    lead.documentUpload?.aadhaarFrontUrl &&
    lead.documentUpload?.aadhaarBackUrl &&
    lead.documentUpload?.panCardUrl
  ) {
    return 3;
  }

  if (lead.assetAllocation?.batteryImei) {
    return 1;
  }

  if (lead.driverInformation) {
    return 1;
  }

  return null;
};

export const mapLeadToFormData = (lead) => ({
  driverInformation: {
    driverName: lead?.driverName || "",
    phoneNumber: lead?.phoneNumber || "",
    age: lead?.age || "",
    city: lead?.city || "",
    invoiceValue: lead?.invoiceValue || "",
    downpayment: lead?.downpayment || "",
    emiTenure: lead?.emiTenure || "",
    vehicleFinanced: lead?.vehicleFinanced || "",
    vehicleFinancierDetails: {
      name: lead?.vehicleFinancierDetails?.name || "",
      phoneNumber: lead?.vehicleFinancierDetails?.phoneNumber || "",
      address: lead?.vehicleFinancierDetails?.address || "",
    },
  },

  assetAllocation: {
    batteryType: lead?.assetAllocation?.batteryType || "",
    batteryImei: lead?.assetAllocation?.batteryImei || "",
    chargerId: lead?.assetAllocation?.chargerId || "",
  },

  documentUpload: {
    aadhaarFrontUrl: lead?.documentUpload?.aadhaarFrontUrl || null,
    aadhaarBackUrl: lead?.documentUpload?.aadhaarBackUrl || null,
    panCardUrl: lead?.documentUpload?.panCardUrl || null,
    rcFrontUrl: lead?.documentUpload?.rcFrontUrl || null,
    rcBackUrl: lead?.documentUpload?.rcBackUrl || null,
    addressProofUrl: lead?.documentUpload?.addressProofUrl || null,
    crifReportUrl: lead?.documentUpload?.crifReportUrl || null,
  },

  financierSelection: {
    selectedFinancier: lead?.financierSelection?.selectedFinancier || "",
  },
});

export const getUploadedDocuments = (documentUpload) => ({
  aadhaarFrontUrl: documentUpload?.aadhaarFrontUrl,
  aadhaarBackUrl: documentUpload?.aadhaarBackUrl,
  panCardUrl: documentUpload?.panCardUrl,
  rcFrontUrl: documentUpload?.rcFrontUrl,
  rcBackUrl: documentUpload?.rcBackUrl,
  addressProofUrl: documentUpload?.addressProofUrl,
  crifReportUrl: documentUpload?.crifReportUrl,
});

export const hasNewDocuments = (currentDocs, savedDocs) =>
  !isEqual(getUploadedDocuments(currentDocs), getUploadedDocuments(savedDocs));
